import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/app/duty-roster")({
  beforeLoad() {
    // the original component of this route moved. Redirect in case users bookmarked it.
    throw redirect({
      to: "/app/duties/print",
    })
  },
})
